import env from '../.env.json';

export default env;
